Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingImage3707007324",
  {"root":"OfferingImage3707007324--root"},
  "",
  1,
  "OfferingImage3707007324"
);

